import React from "react";
import ReactTable from "@dhn/components/molecules/data-table";
import { Button, Col, FormGroup, Input, Row } from "reactstrap";
import EnabledButton from "../../../../../../../@dhn/components/molecules/button-enabled";
import { orderBy } from "lodash";
import ModalAddAndEditUser from "./modals/ModalAddAndEditUser";
import { getWorkTeamStatus } from "../../../../utils/work-team-rows";

import StatusBadge from "@dhn/components/molecules/status-badge";
export default function WorkTeamSubTab({
  state,
  rows = [],
  onChange,
  optionProfiles,
  dataUserSelected,
  onAddAndModifyUser,
  toggle,
  modalAddAndEditIsOpen,
  isNew,
  isMedical,
  medicalSelected,
  showPassword,
  branchSelected,
  profileSelected,
  onAddAndModifyUserMedical,
  mapDataSearch,
  actionsButtonEditUser,
  onRemoveUnsavedUser,
  addToast,
  schedulingFormat,
  scheduleSelected,
}) {
  const maskCedula = (value = "") => {
    if (!value) return "";

    // Deja solo los dígitos
    const digits = String(value).replace(/\D/g, "");

    // La cédula dominicana son 11 dígitos: 000-0000000-0
    if (digits.length !== 11) return value; // si no cuadra, la dejo igual

    return `${digits.slice(0, 3)}-${digits.slice(3, 10)}-${digits.slice(10)}`;
  };

  return (
    <div className="animated fadeIn">
      <ModalAddAndEditUser
        onChange={onChange}
        toggle={toggle}
        optionProfiles={optionProfiles}
        dataUserSelected={dataUserSelected}
        onAddAndModifyUser={onAddAndModifyUser}
        isOpen={modalAddAndEditIsOpen}
        isNew={isNew}
        isMedical={isMedical}
        medicalSelected={medicalSelected}
        showPassword={showPassword}
        branchSelected={branchSelected}
        profileSelected={profileSelected}
        onAddAndModifyUserMedical={onAddAndModifyUserMedical}
        addToast={addToast}
        schedulingFormat={schedulingFormat}
        scheduleSelected={scheduleSelected}
        state={state}
      />
      <Row form className="my-3">
        <Col md={8}>
          <Input
            type="text"
            placeholder="Buscar Usuario"
            onChange={({ target: { value } }) => {
              const searchValue = value.toLocaleLowerCase();
              const dataSearch = rows.filter((item) => {
                const fullName = `${item.firstName || ""}${
                  item.lastName || ""
                }`.toLowerCase();
                return item.firstName && fullName.includes(searchValue);
              });
              onChange("mapDataSearch", dataSearch);
            }}
          />
        </Col>
        <Col md="auto" className="ml-auto">
          <Button
            color="primary"
            className="btn-color-primary"
            onClick={() => {
              onChange("isLoadingDhn", true);
              onChange("modalAddAndEditIsOpen", true);
              onChange("isNewUser", true);
              onChange("isLoadingDhn", false);
            }}
          >
            <i className="fa fa-plus"></i>
            {" Agregar"}
          </Button>
        </Col>
      </Row>

      <Row form>
        <Col md={12}>
          <ReactTable
            defaultPageSize={10}
            className="-striped -highlight mt-2"
            data={
              orderBy(
                mapDataSearch?.length ? mapDataSearch : rows,
                ["enabled", "firstName"],
                ["desc", "asc"]
              ) || []
            }
            columns={[
              {
                Header: "Nombre",
                Cell: ({ original }) =>
                  `${original.firstName} ${original.lastName}`,
              },
              {
                Header: "No. de Identificación",
                className: "text-center",
                minWidth: 50,
                Cell: ({ original }) => maskCedula(original?.identification),
              },
              {
                Header: "Perfil",
                Cell: ({ original }) => {
                  return (
                    <div>
                      {optionProfiles.find(
                        (item) => item?.id === original?.profileId
                      )?.name || original.profile?.name}
                    </div>
                  );
                },
              },
              {
                Header: "Estado",
                className: "text-center",
                width: 120,
                Cell: ({ original }) => {
                  const status = getWorkTeamStatus(original);
                  return (
                    <StatusBadge
                      color={status.color}
                      title={original?.rejectionReason || status.label}
                    >
                      {status.label}
                    </StatusBadge>
                  );
                },
              },
              {
                Header: "Opciones",
                minWidth: 50,
                Cell: ({ original }) => {
                  // Las solicitudes se revisan desde el módulo de cuentas de usuario.
                  if (original?.preregistrationId) return null;

                  return (
                    <FormGroup>
                      <Button
                        color="secondary"
                        type="button"
                        onClick={() => actionsButtonEditUser(original)}
                        className="btn-color-gray card-header-action"
                      >
                        <i className="fa fa-pencil"></i>
                        {" Editar"}
                      </Button>
                      <EnabledButton
                        status={original.medicalStaffProviderEnabled}
                        onClick={() => {
                          onAddAndModifyUser(original);
                        }}
                      />
                      {original?.isPendingSave && (
                        <Button
                          color="danger"
                          type="button"
                          className="btn-color-danger card-header-action ml-1"
                          title="Borrar usuario no guardado"
                          onClick={() => onRemoveUnsavedUser(original)}
                        >
                          <i className="fa fa-trash"></i>
                          {" Borrar"}
                        </Button>
                      )}
                    </FormGroup>
                  );
                },
              },
            ]}
          />
        </Col>
      </Row>
    </div>
  );
}
